import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeScreenComponent} from './home-screen/home-screen.component';
import {PublicLayoutComponent} from './public-layout/public-layout.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { OnlineApplicationOneComponent } from './online-application-one/online-application-one.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';

const routes: Routes = [
    {
      path: '',
      redirectTo: '/dashHome',
      pathMatch: 'full'
    },
    {
      path: '',
      component: PublicLayoutComponent,
      children: [
          {
              path: 'login',
              component: LoginComponent
          },
          {
            path: 'register',
            component: RegisterComponent
        },
        {
          path: 'reset',
          component: ResetPasswordComponent
        },
        {
          path: 'home',
          component: HomeScreenComponent
      },
        {
          path: 'forgot-password',
          component: ForgotPasswordComponent
        },
      {
        path: 'onlineApp1',
        component: OnlineApplicationOneComponent
    },
      ]
  }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule {
}
